import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`text-2xl font-heading font-bold ${scrolled || !isHome ? 'text-primary-500' : 'text-white'}`}>
              每日吃瓜
            </span>
            {!scrolled && isHome && (
              <span className="hidden sm:inline text-xs bg-accent-500 text-background-50 px-2 py-0.5 rounded-full">
                HOT
              </span>
            )}
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/90 hover:text-white'
              } ${location.pathname === '/' ? (scrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors ${
                  scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/90 hover:text-white'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/90 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors cursor-pointer ${
              scrolled || !isHome ? 'bg-background-100 hover:bg-background-200 text-foreground-600' : 'bg-white/20 hover:bg-white/30 text-white'
            }`}>
              <i className="ri-search-line text-lg"></i>
            </button>
          </div>

          <button
            className={`md:hidden w-9 h-9 rounded-full flex items-center justify-center cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className="text-sm text-foreground-700 py-2 hover:text-primary-500">首页</Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="text-sm text-foreground-700 py-2 hover:text-primary-500"
            >
              {cat.name}
            </Link>
          ))}
          <Link to="/about" className="text-sm text-foreground-700 py-2 hover:text-primary-500">关于我们</Link>
        </div>
      )}
    </nav>
  );
}